/** The EGKA emblem (the circle from the official logo, cropped by CSS from the full logo file). */
export function Emblem({ size = 40 }: { size?: number }) {
  return (
    <span className="block flex-none overflow-hidden" style={{ width: size, height: size }}>
      <img src="/egka-logo.png" alt="EGKA" style={{ height: size, width: 'auto', maxWidth: 'none' }} />
    </span>
  );
}

/**
 * The hanko seal: shown only on a current membership, so it means something.
 * 会員 = member. Decorative alongside a text status, so hidden from screen readers.
 */
export function Seal({ size = 48 }: { size?: number }) {
  return (
    <span aria-hidden="true" className="flex flex-none -rotate-[4deg] items-center justify-center rounded-[3px] bg-brand-600 font-jp font-extrabold leading-[1.05] text-white"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.33) }}>
      <span className="text-center">会<br />員</span>
    </span>
  );
}
